import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Field, MonoInput } from '../components/Field.jsx';

export default function Login() {
  const [pin, setPin] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      const r = await fetch('/api/verify-pin', {
        method: 'POST', credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ pin }),
      });
      if (!r.ok) {
        const d = await r.json().catch(() => ({}));
        setErr(d.message || 'invalid pin');
      } else {
        nav('/', { replace: true });
      }
    } catch (e) {
      setErr(String(e.message || e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: 'var(--bg-soft)' }}>
      <div className="fade-in" style={{ width: '100%', maxWidth: 380, padding: 'var(--space-6)' }}>
        <Link to="/" className="brand" style={{ marginBottom: 'var(--space-6)' }}>
          <span className="brand-mark">M</span>
          <span>MindReadir</span>
        </Link>
        <div className="card card-pad" style={{ marginTop: 'var(--space-6)' }}>
          <div className="page-eyebrow" style={{ marginBottom: 4 }}>Press Engine</div>
          <h2 style={{ marginBottom: 'var(--space-4)' }}>Sign in</h2>
          <form onSubmit={onSubmit} className="stack-3">
            <Field label="PIN" required htmlFor="pin"
              error={err || null}
              help={err ? null : 'The PIN you set in your Netlify env vars.'}>
              <MonoInput
                id="pin"
                type="password"
                value={pin}
                onChange={e => setPin(e.target.value)}
                autoFocus
                inputMode="numeric"
              />
            </Field>
            <button type="submit" className="btn btn-lg" disabled={busy || !pin} style={{ width: '100%' }}>
              {busy ? <><span className="spinner" /> Checking</> : 'Enter'}
            </button>
          </form>
        </div>
        <p className="muted" style={{ fontSize: 12, marginTop: 'var(--space-4)', textAlign: 'center' }}>
          Single-tenant. One Adam. No public signups.
        </p>
      </div>
    </div>
  );
}
